import Competencies from './Competencies';
export default Competencies;